import { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SlotsDayView from './SlotsDayView';
import { ProfileStatus } from './ProfileStatus';
import { HolidaysDaysCell } from './HolidaysDaysCell';
import { ProfileStatusPushButton } from './ProfileStatusPushButton'
import { TablePagination } from './TablePagination'
import { QCStatus } from './QCStatus';
import { LastModfiedCell } from './LastModfiedCell';
import { logEventToAnalyticsPlatform } from "../../../helper/events"
import { EVENTS } from "../events_Constant"
import { FEATURE_NAME } from "../constant"
import { getUrlForDoctorProfilePage } from "../Helper/utils"
import UserFeaturesContext  from '../../../hook/UserDetails/UserFeaturesContext'; // Import the context
import {checkFeatureFeasbility} from '../../../helper/utils'



const headCells = [
  {
    id: 'profile',
    disablePadding: false,
    label: 'Doctor Name & ID',
    minWidth: 300,
  },
  {
    id: 'Slots',
    disablePadding: false,
    label: 'Working Days & Timings',
    minWidth: 350
  },
  {
    id: 'Holidays',
    numeric: true,
    disablePadding: false,
    label: 'Upcoming Holidays',
    minWidth: 200
  },
  {
    id: 'Profile Status',
    numeric: true,
    disablePadding: false,
    label: 'Profile Status',
    minWidth: 175
  },
  {
    id: 'QC Status',
    numeric: true,
    disablePadding: false,
    label: 'QC Status',
    minWidth: 175
  },
  {
    id: 'Speciality',
    numeric: true,
    disablePadding: false,
    label: 'Speciality',
    minWidth: 175
  },
  {
    id: 'Provider',
    numeric: true,
    disablePadding: false,
    label: 'Provider',
    minWidth: 300
  },
  {
    id: 'Consultation Fee',
    disablePadding: false,
    label: 'Consultation Fee',
    minWidth: 150
  },
  {
    id: 'Last Modified',
    disablePadding: false,
    label: 'Last Modified',
    minWidth: 300
  }
];

function EnhancedTableHead(props) {
  const { headCells, totalRecords } = props
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <>
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={'normal'}
              className={`${headCell.id === 'profile' ? 'w-72 sticky left-0 bg-gray-100 bg-opacity-100 z-10 ' : 'bg-gray-100 '} `}
              sx={{ minWidth: headCell.minWidth, 'color': '#596C86', 'fontSize': '12px', 'font-weight': 500, borderRight: '1px solid #ddd', }}
            >
              {headCell.label}{headCell.id === 'profile' ? ` (${totalRecords})` : ' '}
            </TableCell>
          </>
        ))}
      </TableRow>
    </TableHead>
  );
}



export const DoctorTable = ({ setPage, totalRecords, page, ...props }) => {
  const { doctors } = props.doctorList;
  const [selected, setSelected] = useState([]);
  const history = useHistory();
  const { userFeatures } = useContext(UserFeaturesContext);

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };


  const handleClickOpen = (drId, providerId) => {
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_LS_ACTION.name,
      payload: {
        tab_name: EVENTS.TAB_NAME_LC_SCREEN,
        filterValue: '',
        reference_id: '' + drId,
        reference_provider_id: '' + providerId,
        service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
        action: EVENTS.ACTION.EDIT_DOCTOR_ICON,
      },
      schema: EVENTS.PC_LS_ACTION.schema,
    })
    const url = getUrlForDoctorProfilePage(drId);
    history.push(url);
  };

  const emptyRows = 10 - doctors.length;

  return (
    <>
      <Box sx={{ width: '100%' }} className='px-8'>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table
              aria-labelledby="tableTitle"
              size={'medium'}
              sx={{ minWidth: 750, borderRadius: '10px' }}
            >
              <EnhancedTableHead
                headCells={headCells}
                totalRecords={totalRecords}
              />
              <TableBody>
                {doctors?.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}${row.doctorId}`;
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      tabIndex={-1}
                      sx={{
                        cursor: checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR, userFeatures)
                          ? 'pointer'
                          : 'default'
                      }}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 items-center sticky left-0 bg-white  z-10  "
                        sx={{
                          borderRight: '1px solid #ddd',
                        }}
                      >
                        <div className="flex gap-2  items-center w-full">
                          <ProfileStatus
                            statusValue={row.profilePercentComplete}
                            statusImage={row.doctorImageUrl ? row.doctorImageUrl : "https://views.medibuddy.in/providerUi/assets/DoctorPlaceholder.svg"}
                          />
                          <div className="flex flex-col flex-1">
                            <p className=' text-sm font-medium underline decoration-mb-blue-400 text-mb-blue-400'
                              onClick={(e) => {checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR, userFeatures) && handleClickOpen(row?.doctorId, row?.providerId) }}
                            >
                              {row?.doctorprefix || row?.doctorprefix === '' ? row?.doctorprefix : 'Dr.'} {row?.doctorFirstName} {row?.doctorLastName}
                            </p>
                            <p className="text-s text-gray-500 ">
                              {row?.doctorId}
                            </p>
                          </div>
                          {checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR, userFeatures) && <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => {handleClickOpen(row?.doctorId) }} style={{ cursor: 'pointer' }} />}
                        </div>
                      </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }}>{<SlotsDayView doctorSlots={row.doctorSlots} doctorId={row.doctorId} providerId={row.providerId} slotProperties={row.slotProperties} />}</TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }} ><HolidaysDaysCell holidays={row.holidays} doctorId={row.doctorId} providerId={row.providerId} /></TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }} ><ProfileStatusPushButton profileStatus={row.doctorIsActive} doctorId={row.doctorId} providerId={row.providerId} /> </TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }} ><QCStatus qcStatus={row.doctorQCStatus} qcRemarks={row.doctorQCRemarks} /></TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }} >{row.doctorSpecialization}</TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd' }} >{row.providerName} <br /> {row.providerLocation}, {row.providerCity}</TableCell>
                      <TableCell align="left" sx={{ borderRight: '1px solid #ddd', width: '100px' }} > &#8377;{row?.priceDetails?.customerFee} </TableCell>
                      <TableCell align="left"
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className="flex gap-2 justify-center">

                        <LastModfiedCell doctorModifiedOn={row.doctorModifiedOn} doctorModifiedBy={row.doctorModifiedBy} />

                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (60) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <div className="flex relative justify-end w-full items-end px-8 py-4 ">
        <TablePagination setPage={setPage} page={page} totalRecords={totalRecords} />
      </div>
    </>

  );
}